<template>
  <div class="recharge-dialog-widget-panel" ref="rechargeDialogPage" v-if="rechargeDialogShow" @touchmove.stop>
    <div class="recharge-widget-dialog" ref="rechargeDialog">
      <div class="recharge-title-panel">
        <div :class="'title-item '+(type==pay.type?'active':'') " v-for="(pay,index) in pList" @click="choose(pay)">
          {{pay.title}}
        </div>
      </div>
      <div class="recharge-panel">
        <div class="recharge-item" v-for="(item) in (pay.products||[])" @click="doPay(pay,item)">
          <div class="coin-panel" v-if="item.productType!=3">
            <div class="base-count" v-text="item.baseCount"></div>
            <div class="extra-count" v-text="'+'+item.extraCount"></div>
          </div>
          <div class="coin-panel sVip" v-if="item.productType==3">
            <div class="sVip">1 month</div>
          </div>
          <div class="price-panel">
            <div class="actual-price" v-text="'$'+item.priceUSD"></div>
            <div class="old-price" v-text="'$'+item.oriPriceUSD"
                 v-if="item.priceUSD!=item.oriPriceUSD && item.oriPriceUSD>0"></div>
          </div>
        </div>
        <div class="space-helper"></div>
      </div>
      <div class="recharge-btm-panel">
        <div class="recharge-icn"></div>
        <div class="coin-balance" v-text="balance"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import {isnull} from "../../utils/tools";
  import liveApi from '../../api/live-api'
  import global from "../../config/global";
  import FBQ from "../../utils/fbqutils";
  import StatisticsHelper from "../../utils/StatisticsUtils";
  import EventBusConstant from "../../push/const/EventBusConstant";

  export default {
    name: "rechargedialog",
    props: {
      rechargeDialogShow: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        pList: [],
        type: 0,
        pay: {},
        balance: 0,
      }
    },
    mounted() {
      document.addEventListener("click", this.bodyCloseGiftDialog);
    },
    beforeUpdate() {

    },
    beforeDestroy() {
      document.removeEventListener("click", this.bodyCloseGiftDialog);
    },
    methods: {
      choose(pay) {
        this.type = pay.type
        this.pay = pay
      },
      doPay(pay, item) {
        this.$EventBus.$emit(EventBusConstant.EVENT_RECHARGE_PAY, pay, item)
      },
      checkExist(data) {
        return !isnull(data)
      },
      hideSelfRechargeDialog() {
        this.$emit("hideRecharge");
      },
      bodyCloseRechargeDialog(e) {
        let self = this;
        if (this.$refs.rechargeDialog && !this.$refs.rechargeDialog.contains(e.target)) {
          self.hideSelfRechargeDialog();
        }
      },
      bundleData() {
        this.balance = global.getUserCoins()
        this.pList = global.getPList()
        if (!isnull(this.pList)) {
          this.pay = this.pList[0]
          this.type = this.pay.type
        }
      },
    },
    watch: {
      rechargeDialogShow(n, o) {
        if (n) {
          $('.page-container').scrollTop(0)
          $('.page-container').css('overflow-y', 'hidden')
          let target = this
          setTimeout(function () {
            target.bundleData();
            target.$refs.rechargeDialogPage.addEventListener("click", target.bodyCloseRechargeDialog);
          }, 100)

        } else {
          $('.page-container').css('overflow-y', 'auto')
          this.$refs.rechargeDialogPage.removeEventListener("click", this.bodyCloseRechargeDialog);
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .recharge-dialog-widget-panel {
    position: fixed;
    z-index: 12;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }

  .recharge-widget-dialog {
    width: 100%;
    .h(604);
    position: fixed;
    z-index: 3;
    bottom: 0;
    .b-radius(24, 24, 0, 0);
    background-color: rgba(0, 0, 0, .8);
    backdrop-filter: blur(0px);
    font-family: Gilroy-Medium;

    .recharge-title-panel {
      text-align: left;
      .mt(27);
      .ml(29);
      .mr(29);
      white-space: nowrap;
      overflow-x: auto;

      .title-item {
        .fs(32);
        font-family: Gilroy-Bold;
        color: rgba(255, 255, 255, .6);
        .lh(32);
        display: inline-block;
        .mr(42);
      }

      .title-item.active {
        color: rgba(255, 255, 255, 1);
      }

      .title-item.active::after {
        content: '';
        .w(12);
        .h(6);
        background: #fff;
        .b-radius(3);
        display: block;
        .mt(11);
        margin-left: 50%;
        transform: translateX(-50%);
      }
    }

    .recharge-panel {
      .h(595);
      .mt(9);
      text-align: left;
      overflow-y: auto;
      font-size: 0;

      .recharge-item {
        .mt(30);
        .h(200);
        width: calc(33.3vw - .59rem);
        .b-radius(24);
        margin-left: .44rem;
        background: #fff;
        display: inline-block;
        text-align: center;

        .coin-panel {
          width: 100%;
          color: #1a1a1c;
          font-family: Gilroy-Bold;
          color: #1A1A1C;
          .lh(44);
          overflow: hidden;
          text-align: center;
          .mt(30);

          .base-count, .sVip {
            .fs(44);
            display: inline-block;
          }

          .extra-count {
            .fs(24);
            display: inline-block;
          }
        }

        .coin-panel::before {
          content: '';
          background: url("../../assets/imgs/recharge-coin.png") no-repeat;
          background-size: 40/@baseFontSize*1rem 40/@baseFontSize*1rem;
          .w(40);
          .h(40);
          .mb(10);
          display: block;
          margin-left: 50%;
          transform: translateX(-50%);
        }

        .coin-panel.sVip::before {
          content: '';
          background: url("../../assets/imgs/recharge-svip.png") no-repeat;
          background-size: 97/@baseFontSize*1rem 40/@baseFontSize*1rem;
          .w(97);
          .h(40);
          .mb(10);
          display: block;
          margin-left: 50%;
          transform: translateX(-50%);
        }

        .price-panel {
          width: 100%;
          .h(60);
          background: linear-gradient(270deg, #FB5F7C 0%, #FF32A1 100%);
          .b-radius(0, 0, 20, 20);
          .mt(16);

          .actual-price {
            .fs(30);
            font-family: Gilroy-Bold;
            color: rgba(255, 255, 255, 1);
            line-height: 30px;
            display: inline-block;
          }

          .old-price {
            .ml(14);
            .fs(22);
            font-family: Gilroy-Bold;
            color: rgba(255, 255, 255, .6);
            line-height: 30px;
            text-decoration: line-through;
            display: inline-block;
          }
        }
      }


      .space-helper {
        width: 100%;
        .h(150);
      }
    }

    .recharge-panel::-webkit-scrollbar, .recharge-title-panel::-webkit-scrollbar {
      display: none;
    }

    .recharge-btm-panel {
      left: 0;
      right: 0;
      .h(100);
      position: fixed;
      bottom: 0;
      background: url(../../assets/imgs/gift-title-bg.png) no-repeat;
      background-size: cover;

      .recharge-icn {
        .w(160);
        float: left;
        .h(36);
        .ml(30);
        .mt(32);
        background: url(../../assets/imgs/recharge-dialog-icn.png) no-repeat;
        background-size: contain;
      }


      .coin-balance {
        .mt(32);
        .fs(32);
        font-weight: 800;
        color: #FFF;
        .lh(32);
        position: fixed;
        .right(39);
      }

      .coin-balance:before {
        content: '';
        background: url(../../assets/imgs/gift-title-coin.png) no-repeat;
        background-size: contain;
        .w(36);
        .h(36);
        display: inline-block;
        .mr(12);
        vertical-align: text-top;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/widget/rechargedialog.vue